<div class="card p-4">
  <span class="font-semibold text-lg text-gray-700">Catalogue</span>

  <base-data-table
    [count]="count"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    (onPageEvent)="onPageEvent.emit($event)"
    (onSortEvent)="onSortEvent.emit($event)"
    [feisColumns]="feisColumns"
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumnsCatalog"
    [customColumnTemplate]="templateRef"
    [showSort]="true"
    [showPaginator]="true"
  ></base-data-table>
</div>

<ng-template #templateRef let-column let-row="element" let-status="status">
  <!-- Quantité : stepper 0.25 + jours pour les tickets COMPETENCE, sinon colonne quantité standard -->
  <ng-container *ngIf="column === 'quantity'">
    <ng-container *ngIf="isCompetence; else standardQuantity">
      <!-- PRED-3286 : total calculé par le back, non saisissable -->
      <span *ngIf="quantityReadonly; else competenceStepper" class="whitespace-nowrap">
        {{ quantityMax | number: '1.2-2' }} h
      </span>
      <ng-template #competenceStepper>
        <quantity-stepper
          [quantity]="row.quantity"
          [step]="quantityStep"
          [max]="quantityMax"
          [disabled]="disabled"
          [hint]="(quantityInDays(row.quantity) | number: '1.2-2') + ' j'"
          (quantityChange)="onCatalogStepperChange(row, $event)"
        ></quantity-stepper>
      </ng-template>
    </ng-container>
    <ng-template #standardQuantity>
      <catalog-quantity-column-base
        [column]="column"
        [row]="row"
        [readonly]="disabled"
        (addItem)="onAddToBasketEvent.emit($event)"
        (updateQuantityItem)="updateCatalogueQuantity($event.item, $event.action)"
      ></catalog-quantity-column-base>
    </ng-template>
  </ng-container>

  <catalog-quantity-column-base
    *ngIf="column === 'addToCart'"
    [column]="column"
    [row]="row"
    [readonly]="disabled"
    (addItem)="onAddToBasketEvent.emit($event)"
    (updateQuantityItem)="updateCatalogueQuantity($event.item, $event.action)"
  ></catalog-quantity-column-base>

  <div *ngIf="column === 'delete' && canDelete(row) && !disabled">
    <button (click)="deleteReference(row)" class="text-red" mat-icon-button>
      <mat-icon [icIcon]="icDelete"></mat-icon>
    </button>
  </div>

  <div *ngIf="column === 'isProduct'">
    <span *ngIf="row.isProduct">Article</span>
    <span *ngIf="!row.isProduct">Prestation</span>
  </div>

  <div
    *ngIf="column === 'label'"
    class="relative flex items-center"
    (mouseenter)="showComment = row._id"
    (mouseleave)="showComment = null"
  >
    <span>{{ row.label }}</span>
    <div [hidden]="showComment !== row._id" class="tooltip-box__content">
      <div
        *ngIf="row.comment"
        class="p-2 bg-gray-100 border rounded shadow-lg max-w-3xl overflow-auto"
        [innerHTML]="row.comment"
      ></div>
      <div *ngIf="!row.comment" class="p-2 bg-gray-100 border rounded shadow-lg">Aucune description</div>
    </div>
  </div>

  <div
    *ngIf="column === 'reference'"
    class="relative flex items-center"
    (mouseenter)="showPreviousReference = row._id"
    (mouseleave)="showPreviousReference = null"
  >
    <span>{{ row.reference }}</span>
    <div [hidden]="showPreviousReference !== row._id" class="tooltip-box__content">
      <div
        *ngIf="row.previousReference"
        class="p-2 bg-gray-100 border rounded shadow-lg max-w-3xl overflow-auto"
        [innerHTML]="row.previousReference"
      ></div>
    </div>
  </div>

  <div *ngIf="column === 'supplier.label'" class="flex items-center gap-2">
    <span
      class="inline-flex items-center gap-1"
      [class.text-blue-600]="row.isSupportEstablishment"
      [class.font-semibold]="row.isSupportEstablishment"
    >
      <mat-icon *ngIf="row.isSupportEstablishment" class="text-sm" style="font-size: 16px; width: 16px; height: 16px">
        business
      </mat-icon>
      {{ row.supplier?.label || '' }}
    </span>
  </div>

  <div *ngIf="column === 'moreInfo' && hasMoreInfo(row)">
    <button (click)="openMoreInfoModal(row)" mat-icon-button color="primary">
      <mat-icon>file_open</mat-icon>
    </button>
  </div>
</ng-template>
